// Generated by ReScript, PLEASE EDIT WITH CARE
'use strict';

var Curry = require("bs-platform/lib/js/curry.js");
var LogIO = require("./LogIO.bs.js");
var TypeUtils = require("./types/TypeUtils.bs.js");
var Relude_Int = require("relude/src/Relude_Int.bs.js");
var Relude_List = require("relude/src/Relude_List.bs.js");
var StringUtils = require("./StringUtils.bs.js");
var FastSha256 = require("fast-sha256");
var Relude_Array = require("relude/src/Relude_Array.bs.js");
var Relude_Float = require("relude/src/Relude_Float.bs.js");
var Relude_Option = require("relude/src/Relude_Option.bs.js");
var Relude_Result = require("relude/src/Relude_Result.bs.js");
var Relude_Globals = require("relude/src/Relude_Globals.bs.js");

var OTPKey = TypeUtils.MakeOpaqueStringType({});

function make(param, param$1) {
  return Relude_Globals.flip((function (prim, prim$1) {
                return FastSha256.hmac(prim, prim$1);
              }), param, param$1);
}

var Hmac = {
  make: make
};

function $$parseInt$1(numberBaseOpt, maybeInt) {
  var numberBase = numberBaseOpt !== undefined ? numberBaseOpt : 10;
  try {
    return Relude_Result.pure(parseInt(maybeInt, numberBase));
  }
  catch (exn){
    return Relude_Result.error("parseInt failed: " + (maybeInt + (", " + Relude_Int.toString(numberBase))));
  }
}

function intToBytes(_bytesOpt, _num) {
  while(true) {
    var bytesOpt = _bytesOpt;
    var num = _num;
    var bytes = bytesOpt !== undefined ? bytesOpt : /* [] */0;
    if (Relude_Int.eq(8, Curry._1(Relude_List.length, bytes))) {
      return bytes;
    }
    _num = (num >> 8);
    _bytesOpt = {
      hd: num & 255,
      tl: bytes
    };
    continue ;
  };
}

var testRegex = /^[0-9]{4}$/;

function fromString(str) {
  if (testRegex.test(str)) {
    return str;
  }
  
}

var include = TypeUtils.MakeCustomOpaqueStringType({
      fromString: fromString,
      toString: Relude_Globals.id
    });

var fromString$1 = include.fromString;

var eq = include.eq;

var OTP_toString = include.toString;

var OTP_decode = include.decode;

var OTP_encode = include.encode;

var OTP_compare = include.compare;

var OTP_Ord = include.Ord;

var OTP_Set = include.$$Set;

var OTP_Map = include.$$Map;

var OTP = {
  fromString: fromString$1,
  toString: OTP_toString,
  decode: OTP_decode,
  encode: OTP_encode,
  compare: OTP_compare,
  eq: eq,
  Ord: OTP_Ord,
  $$Set: OTP_Set,
  $$Map: OTP_Map
};

var ResultWithString = Relude_Result.WithError({});

function bytesToOtp(bytes) {
  return Relude_Result.flatMap((function (param) {
                return Relude_Globals.$great$great((function (param) {
                              return Relude_Globals.$great$great((function (param) {
                                            return Relude_Globals.$great$great(Relude_Int.toString, (function (param) {
                                                          return StringUtils.leftPad("0", 4, param);
                                                        }), param);
                                          }), fromString$1, param);
                            }), (function (param) {
                              return Relude_Result.fromOption("Could not convert bytes to otp", param);
                            }), param);
              }), Relude_Result.flatMap((function (offset) {
                    return Curry._2(ResultWithString.mapTuple4, (function (v0, v1, v2, v3) {
                                  return (((v0 & 127) << 24) | ((v1 & 255) << 16) | ((v2 & 255) << 8) | v3 & 255) % 10000;
                                }), [
                                Relude_Result.fromOption("No byte at offset " + Relude_Int.toString(offset), Relude_List.at(offset, bytes)),
                                Relude_Result.fromOption("No byte at offset " + (Relude_Int.toString(offset) + " + 1"), Relude_List.at(offset + 1 | 0, bytes)),
                                Relude_Result.fromOption("No byte at offset " + (Relude_Int.toString(offset) + " + 2"), Relude_List.at(offset + 2 | 0, bytes)),
                                Relude_Result.fromOption("No byte at offset " + (Relude_Int.toString(offset) + " + 3"), Relude_List.at(offset + 3 | 0, bytes))
                              ]);
                  }), Relude_Result.map((function (x) {
                        return x & 15;
                      }), Relude_Result.fromOption("No byte at position 19", Relude_List.at(19, bytes)))));
}

function generateOtp(counterOpt) {
  var counter = counterOpt !== undefined ? counterOpt : 0;
  var partial_arg = Relude_List.toArray(intToBytes(undefined, counter)).join("");
  var partial_arg$1 = function (param) {
    return make(partial_arg, param);
  };
  var partial_arg$2 = function (param) {
    return Relude_Globals.$great$great(partial_arg$1, Relude_Array.toList, param);
  };
  return function (param) {
    return Relude_Globals.$great$great(partial_arg$2, bytesToOtp, param);
  };
}

function verifyOtp(_windowOpt, _counterOpt, key, token) {
  while(true) {
    var windowOpt = _windowOpt;
    var counterOpt = _counterOpt;
    var $$window = windowOpt !== undefined ? windowOpt : 0;
    var counter = counterOpt !== undefined ? counterOpt : 0;
    if (Curry._2(Relude_Int.OrdNamed.lessThan, 0, $$window)) {
      return false;
    }
    if (Relude_Result.fold((function (param) {
              return Relude_Globals.$$const(false, param);
            }), Curry._1(eq, token), generateOtp(counter)(key))) {
      return true;
    }
    _counterOpt = counter - 1 | 0;
    _windowOpt = $$window - 1 | 0;
    continue ;
  };
}

function generateTimeBasedOtp(time, timeStepInSecondsOpt, key) {
  var timeStepInSeconds = timeStepInSecondsOpt !== undefined ? timeStepInSecondsOpt : 300;
  var t = time.getTime();
  return generateOtp(Relude_Float.floorAsInt(t / 1000.0 / Relude_Int.toFloat(timeStepInSeconds)))(key);
}

function generateTimeBasedOtpForCurrentTime(timeStepInSecondsOpt, key) {
  var timeStepInSeconds = timeStepInSecondsOpt !== undefined ? timeStepInSecondsOpt : 300;
  return LogIO.flatMap(undefined, undefined, undefined, (function (time) {
                return LogIO.fromResult(generateTimeBasedOtp(time, timeStepInSeconds, key));
              }), LogIO.getTimestamp(undefined));
}

function verifyTimeBasedOtp(windowOpt, time, timeStepInSecondsOpt, key, token) {
  var $$window = windowOpt !== undefined ? windowOpt : 1;
  var timeStepInSeconds = timeStepInSecondsOpt !== undefined ? timeStepInSecondsOpt : 300;
  return LogIO.map(undefined, undefined, undefined, (function (counter) {
                return verifyOtp($$window, counter, key, token);
              }), LogIO.map(undefined, undefined, undefined, (function (param) {
                    return Relude_Globals.$great$great((function (param) {
                                  return Relude_Globals.$great$great((function (prim) {
                                                return prim.getTime();
                                              }), (function (t) {
                                                return t / 1000.0 / Relude_Int.toFloat(timeStepInSeconds);
                                              }), param);
                                }), Relude_Float.floorAsInt, param);
                  }), Relude_Option.foldLazy(LogIO.getTimestamp, LogIO.pure, time)));
}

exports.OTPKey = OTPKey;
exports.Hmac = Hmac;
exports.$$parseInt = $$parseInt$1;
exports.intToBytes = intToBytes;
exports.OTP = OTP;
exports.ResultWithString = ResultWithString;
exports.bytesToOtp = bytesToOtp;
exports.generateOtp = generateOtp;
exports.verifyOtp = verifyOtp;
exports.generateTimeBasedOtp = generateTimeBasedOtp;
exports.generateTimeBasedOtpForCurrentTime = generateTimeBasedOtpForCurrentTime;
exports.verifyTimeBasedOtp = verifyTimeBasedOtp;
/* OTPKey Not a pure module */
